(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sya-cart-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sya-cart-personalization')) {
    const drafts = new Map();
    const disabledControls = new Map();
    const inertCheckouts = new Map();
    const cartScope = 'cart-items-component, .cart__ctas, .cart-drawer__summary, cart-note, cart-discount-component, .cart-form';
    const checkoutSelector = '[name="checkout"], a[href*="/checkout"], .additional-checkout-buttons, shopify-accelerated-checkout-cart';
    let activeEditor = null;
    let guardObserver = null;

    const editors = () => Array.from(document.querySelectorAll('sya-cart-personalization'));
    const matchingEditors = (key) => editors().filter((editor) => editor.dataset.lineKey === key);
    const pause = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));

    function refreshGuards() {
      const hasDrafts = editors().some((editor) => drafts.has(editor.dataset.lineKey));
      const shouldLockCheckout = Boolean(activeEditor || hasDrafts);
      if (shouldLockCheckout) {
        document.querySelectorAll('.additional-checkout-buttons, shopify-accelerated-checkout-cart').forEach((element) => {
          if (!inertCheckouts.has(element)) inertCheckouts.set(element, element.inert);
          element.inert = true;
        });
      } else {
        inertCheckouts.forEach((inert, element) => { element.inert = inert; });
        inertCheckouts.clear();
      }

      if (activeEditor) {
        document.querySelectorAll('button, input, textarea, select').forEach((control) => {
          if (!control.closest(cartScope) && control.getAttribute('form') !== 'cart-form') return;
          if (!disabledControls.has(control)) disabledControls.set(control, control.disabled);
          control.disabled = true;
        });
      } else {
        const wasLocked = disabledControls.size > 0;
        disabledControls.forEach((disabled, control) => { control.disabled = disabled; });
        disabledControls.clear();
        if (wasLocked) {
          document.querySelectorAll('cart-quantity-selector-component').forEach((selector) => selector.updateButtonStates?.());
        }
      }

      if (shouldLockCheckout && !guardObserver) {
        guardObserver = new MutationObserver(refreshGuards);
        guardObserver.observe(document.body, { childList: true, subtree: true });
      } else if (!shouldLockCheckout && guardObserver) {
        guardObserver.disconnect();
        guardObserver = null;
      }
    }

    function blockInteraction(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const isCart = target.closest(cartScope) || target.getAttribute('form') === 'cart-form';
      const isCheckout = target.closest(checkoutSelector);
      const isCartSubmit = event.type === 'submit' && target.matches('.cart-form, #cart-form');
      const dirtyEditor = editors().find((editor) => drafts.has(editor.dataset.lineKey));
      if (activeEditor && (isCart || isCheckout)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      } else if (dirtyEditor && (isCheckout || isCartSubmit)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const visibleEditor = editors().find((editor) => drafts.has(editor.dataset.lineKey) && editor.getClientRects().length) || dirtyEditor;
        visibleEditor.showMessage(visibleEditor.dataset.unsavedLabel, true);
        visibleEditor.querySelector('details').open = true;
        visibleEditor.querySelector('[data-save]').focus();
      }
    }

    ['click', 'submit', 'change', 'input', 'quantity-selector:update'].forEach((eventName) => {
      window.addEventListener(eventName, blockInteraction, true);
    });

    document.addEventListener('cart:update', (event) => {
      const items = event.detail?.resource?.items;
      const source = event.detail?.data?.source;
      if (Array.isArray(items) && ['cart-items-component', 'sya-personalization'].includes(source)) {
        const keys = new Set(items.map((item) => item.key));
        drafts.forEach((value, key) => { if (!keys.has(key)) drafts.delete(key); });
      }
      queueMicrotask(refreshGuards);
    }, true);

    class SyaCartPersonalization extends HTMLElement {
      connectedCallback() {
        this.hidden = false;
        this.addEventListener('input', this.handleInput);
        this.addEventListener('click', this.handleClick);
        this.observer = new MutationObserver(() => this.restoreDraft());
        this.observer.observe(this, { childList: true, subtree: true });
        this.restoreDraft();
      }

      disconnectedCallback() {
        this.removeEventListener('input', this.handleInput);
        this.removeEventListener('click', this.handleClick);
        this.observer?.disconnect();
      }

      get fields() {
        return Array.from(this.querySelectorAll('textarea[data-property]'));
      }

      restoreDraft() {
        const draft = drafts.get(this.dataset.lineKey);
        if (draft) this.fields.forEach((field) => { field.value = draft[field.dataset.property] ?? field.defaultValue; });
      }

      showMessage(message, error = false) {
        const output = this.querySelector(error ? '[data-error]' : '[data-status]');
        if (!output) return;
        if (output.textContent !== message) output.textContent = message;
        output.hidden = !message;
      }

      handleInput = (event) => {
        if (!event.target.matches('textarea[data-property]')) return;
        const values = Object.fromEntries(this.fields.map((field) => [field.dataset.property, field.value]));
        const dirty = this.fields.some((field) => field.value !== field.defaultValue);
        if (dirty) drafts.set(this.dataset.lineKey, values);
        else drafts.delete(this.dataset.lineKey);
        matchingEditors(this.dataset.lineKey).forEach((editor) => {
          editor.fields.forEach((field) => { field.value = values[field.dataset.property]; });
          editor.showMessage(dirty ? editor.dataset.unsavedLabel : '');
          editor.showMessage('', true);
        });
        refreshGuards();
      };

      handleClick = (event) => {
        if (event.target.closest('[data-save]')) this.save();
        if (event.target.closest('[data-cancel]')) this.cancel();
      };

      cancel() {
        if (activeEditor) return;
        drafts.delete(this.dataset.lineKey);
        matchingEditors(this.dataset.lineKey).forEach((editor) => {
          editor.fields.forEach((field) => { field.value = field.defaultValue; });
          editor.showMessage('');
          editor.showMessage('', true);
          editor.querySelector('details').open = false;
        });
        this.querySelector('summary').focus();
        refreshGuards();
      }

      async save() {
        if (activeEditor) return;
        if (!this.fields.every((field) => field.value.length <= 250 && field.reportValidity())) return;
        if (document.querySelector('cart-items-component.cart-items-disabled')) {
          this.showMessage(this.dataset.busyLabel, true);
          return;
        }
        const key = this.dataset.lineKey;
        const values = Object.fromEntries(this.fields.map((field) => [field.dataset.property, field.value]));
        drafts.set(key, values);
        activeEditor = this;
        this.setAttribute('aria-busy', 'true');
        this.querySelector('[data-save]').textContent = this.dataset.savingLabel;
        this.showMessage('', true);
        refreshGuards();

        try {
          await pause(350);
          let attempts = 0;
          while (document.querySelector('cart-items-component.cart-items-disabled')) {
            if (++attempts > 100) throw new Error(this.dataset.busyLabel);
            await pause(100);
          }
          const cartUrl = this.dataset.cartUrl.replace(/\/$/, '');
          const currentResponse = await fetch(`${cartUrl}.js`, {
            credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' },
          });
          if (!currentResponse.ok) throw new Error(this.dataset.errorLabel);
          const currentCart = await currentResponse.json();
          const currentItem = currentCart.items?.find((item) => item.key === key);
          if (!currentItem) throw new Error(this.dataset.missingLabel);
          const sections = Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component'))
            .map((component) => component.dataset.sectionId).filter(Boolean)));
          const response = await fetch(`${cartUrl}/change.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: key,
              quantity: currentItem.quantity,
              properties: { ...currentItem.properties, ...values },
              sections: sections.join(','),
              sections_url: window.location.pathname,
            }),
          });
          const cart = await response.json();
          if (!response.ok || cart.errors || !Array.isArray(cart.items)) throw new Error(this.dataset.errorLabel);
          drafts.delete(key);
          matchingEditors(key).forEach((editor) => {
            editor.fields.forEach((field) => { field.defaultValue = values[field.dataset.property]; field.value = values[field.dataset.property]; });
            editor.showMessage('');
            editor.showMessage('', true);
            editor.querySelector('details').open = false;
          });
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'sya-personalization',
              data: { sections: cart.sections, itemCount: cart.item_count, source: 'sya-personalization' },
            },
          }));
        } catch (error) {
          const message = [this.dataset.missingLabel, this.dataset.busyLabel].includes(error.message)
            ? error.message : this.dataset.errorLabel;
          matchingEditors(key).forEach((editor) => {
            editor.restoreDraft();
            editor.showMessage(message, true);
            editor.querySelector('details').open = true;
          });
        } finally {
          activeEditor = null;
          this.removeAttribute('aria-busy');
          const button = this.querySelector('[data-save]');
          if (button) button.textContent = this.dataset.saveLabel;
          refreshGuards();
        }
      }
    }

    customElements.define('sya-cart-personalization', SyaCartPersonalization);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sya-currency-price-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-sya-price-filter]';
    const metadata = new WeakMap();
    let fieldId = 0;
    let scheduled = false;

    const parseMinor = (value) => {
      if (typeof value !== 'string' || !value.trim()) return null;
      if (!/^[\d\s.,']+$/.test(value)) return null;
      const normalized = value.trim().replace(/^([.,])(?=\d)/, '0$1');
      const parts = normalized.split(/[^0-9]/).filter(Boolean);
      if (!parts.length) return null;
      const last = parts.at(-1);
      const decimal = parts.length > 1 && last.length <= 2;
      const whole = decimal ? parts.slice(0, -1).join('') : parts.join('');
      const fraction = decimal ? last.padEnd(2, '0') : '00';
      const result = Number(whole) * 100 + Number(fraction);
      return Number.isSafeInteger(result) ? result : null;
    };

    const factorFor = (source, display, rate) => {
      if (source === display) return 1;
      return source === 'DOP' ? 1 / rate : rate;
    };

    const fieldPairs = (facet) => [...facet.querySelectorAll('[data-sya-price-source]')].map((source) => ({
      source,
      display: source.parentElement.querySelector('[data-sya-price-display]'),
      label: source.parentElement.querySelector('label'),
    })).filter(({ display }) => display instanceof HTMLInputElement);

    const render = () => {
      scheduled = false;
      const state = window.SyaCurrency?.getState();
      document.querySelectorAll(selector).forEach((facet) => {
        const sourceCurrency = facet.dataset.currency;
        const enabled = Boolean(state?.canConvert && ['DOP', 'USD'].includes(sourceCurrency));
        const factor = enabled ? factorFor(sourceCurrency, state.displayCurrency, state.rate) : 1;
        const formatter = new Intl.NumberFormat(state?.locale || 'es-DO', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        fieldPairs(facet).forEach(({ source, display, label }) => {
          let original = metadata.get(source);
          if (!original) {
            original = { labelFor: label?.htmlFor, labelText: label?.textContent, currency: null };
            metadata.set(source, original);
          }
          if (!display.id) display.id = `sya-price-display-${++fieldId}`;
          source.hidden = enabled;
          display.hidden = !enabled;
          display.disabled = !enabled;
          if (label) {
            label.htmlFor = enabled ? display.id : original.labelFor;
            label.textContent = enabled ? (state.displayCurrency === 'DOP' ? 'RD$' : 'US$') : original.labelText;
          }
          if (!enabled) return;
          const nativeMinor = parseMinor(source.value);
          if (nativeMinor !== null && source.value !== (nativeMinor / 100).toFixed(2)) source.value = (nativeMinor / 100).toFixed(2);
          const currencyChanged = original.currency !== state.displayCurrency;
          if (document.activeElement !== display || currencyChanged) {
            const minor = parseMinor(source.value);
            display.value = minor === null ? '' : formatter.format(minor * factor / 100);
            original.displayValue = display.value;
          }
          const placeholder = parseMinor(source.placeholder);
          display.placeholder = placeholder === null ? '' : formatter.format(placeholder * factor / 100);
          display.setAttribute('aria-label', `${display.dataset.syaPriceLabel} ${state.displayCurrency}`);
          original.currency = state.displayCurrency;
        });
      });
    };

    const scheduleRender = () => {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(render);
    };

    const syncSource = (display) => {
      const facet = display.closest(selector);
      const state = window.SyaCurrency?.getState();
      if (!facet || !state?.canConvert) return null;
      const source = display.parentElement.querySelector('[data-sya-price-source]');
      if (!(source instanceof HTMLInputElement)) return null;
      const original = metadata.get(source);
      if (original?.displayValue === display.value) return source;
      const minor = parseMinor(display.value);
      if (minor === null && display.value.trim()) {
        display.setCustomValidity(display.getAttribute('aria-label'));
        display.reportValidity();
        return null;
      }
      display.setCustomValidity('');
      if (minor === null) {
        source.value = '';
      } else {
        const factor = factorFor(facet.dataset.currency, state.displayCurrency, state.rate);
        const native = minor / factor;
        const rounded = source.dataset.syaPriceSource === 'min' ? Math.floor(native + 1e-7) : Math.ceil(native - 1e-7);
        const minimum = parseMinor(source.dataset.min) ?? 0;
        const maximum = parseMinor(source.dataset.max) ?? Number(facet.dataset.syaRangeMax);
        const bounded = Math.min(Math.max(rounded, minimum), maximum);
        if (!Number.isSafeInteger(bounded)) return null;
        source.value = (bounded / 100).toFixed(2);
      }
      return source;
    };

    document.addEventListener('change', (event) => {
      const display = event.target;
      if (!(display instanceof HTMLInputElement) || !display.matches('[data-sya-price-display]')) return;
      event.stopImmediatePropagation();
      const source = syncSource(display);
      if (!source) return;
      source.dispatchEvent(new Event('change', { bubbles: true }));
      const state = window.SyaCurrency.getState();
      const facet = source.closest(selector);
      const formatter = new Intl.NumberFormat(state.locale || 'es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const normalized = parseMinor(source.value);
      display.value = normalized === null ? '' : formatter.format(normalized * factorFor(facet.dataset.currency, state.displayCurrency, state.rate) / 100);
      const original = metadata.get(source);
      if (original) original.displayValue = display.value;
      scheduleRender();
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || !(event.target instanceof HTMLInputElement) || !event.target.matches('[data-sya-price-display]')) return;
      event.preventDefault();
      event.target.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);

    window.addEventListener('submit', (event) => {
      if (!(event.target instanceof Element)) return;
      let invalid = false;
      event.target.querySelectorAll('[data-sya-price-display]').forEach((display) => {
        if (!display.hidden && !display.disabled && !syncSource(display)) invalid = true;
      });
      if (invalid) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    document.addEventListener('input', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.matches('[data-sya-price-display]')) {
        event.target.setCustomValidity('');
      }
    });
    document.addEventListener('sya:currency:change', scheduleRender);
    document.addEventListener('filter:update', scheduleRender);
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => {
        if (mutation.type === 'attributes') return mutation.target.matches(`${selector},[data-sya-price-source]`);
        return [...mutation.addedNodes, ...mutation.removedNodes].some((node) =>
          node instanceof Element && (mutation.target.closest?.(selector) || node.matches(selector) || node.querySelector(selector))
        );
      })) scheduleRender();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'data-min', 'data-max', 'data-currency', 'data-sya-range-max'],
    });
    render();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sya-currency-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const moneySelector = '[data-sya-money]';
    const configSelector = '[data-sya-currency-config]';
    const selectSelector = '[data-sya-currency-select]';
    const noticeSelector = '[data-sya-currency-notice]';
    const storageKey = 'sya-display-currency';
    const currencies = new Set(['DOP', 'USD']);
    const originals = new WeakMap();
    let preference;
    let scheduled = false;
    let currentState = Object.freeze({ source: null, displayCurrency: null, rate: null, locale: 'es-DO', canConvert: false });
    let stateSignature = '';
    window.SyaCurrency = Object.freeze({ getState: () => currentState });

    const readPreference = () => {
      try {
        const value = window.localStorage.getItem(storageKey);
        return currencies.has(value) ? value : null;
      } catch {
        return null;
      }
    };

    const readConfig = () => {
      const node = document.querySelector(configSelector);
      if (!node) return null;
      const rate = Number(node.dataset.dopPerUsd);
      const language = node.dataset.locale || document.documentElement.lang || 'es-DO';
      return {
        rate,
        validRate: Number.isFinite(rate) && rate > 0,
        source: node.dataset.sourceCurrency,
        defaultCurrency: currencies.has(node.dataset.defaultCurrency) ? node.dataset.defaultCurrency : 'DOP',
        locale: language === 'es' ? 'es-DO' : language === 'en' ? 'en-US' : language,
      };
    };

    const formatMoney = (amount, currency, locale) => {
      let formatter;
      try {
        formatter = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } catch {
        formatter = new Intl.NumberFormat('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      return `${currency === 'DOP' ? 'RD$' : 'US$'} ${formatter.format(amount)}`;
    };

    const render = () => {
      scheduled = false;
      const config = readConfig();
      if (preference === undefined && config) preference = readPreference() || config.defaultCurrency;
      const canConvert = Boolean(config?.validRate && currencies.has(config.source));
      const displayCurrency = canConvert ? preference : config?.source;

      document.querySelectorAll(configSelector).forEach((node) => {
        node.hidden = !currencies.has(config?.source);
      });
      document.querySelectorAll(selectSelector).forEach((select) => {
        select.disabled = !canConvert;
        if (currencies.has(displayCurrency) && select.value !== displayCurrency) select.value = displayCurrency;
      });

      document.querySelectorAll(moneySelector).forEach((node) => {
        const rawAmount = node.dataset.amount;
        const minorAmount = Number(rawAmount);
        const sourceCurrency = node.dataset.currency;
        const validAmount = /^\s*-?\d+\s*$/.test(rawAmount || '') && Number.isSafeInteger(minorAmount);
        const signature = `${node.dataset.amount}|${node.dataset.currency}`;
        let original = originals.get(node);
        if (!original || original.signature !== signature || node.innerHTML !== original.renderedHTML) {
          const changedAmountOnly = original && original.signature !== signature && node.innerHTML === original.renderedHTML;
          const nativeHTML = changedAmountOnly && validAmount && currencies.has(sourceCurrency)
            ? formatMoney(minorAmount / 100, sourceCurrency, config?.locale || 'es-DO')
            : node.innerHTML;
          original = { signature, nativeHTML, renderedHTML: node.innerHTML };
          originals.set(node, original);
        }

        if (!canConvert || !currencies.has(sourceCurrency) || !validAmount) {
          if (node.innerHTML !== original.nativeHTML) node.innerHTML = original.nativeHTML;
          original.renderedHTML = node.innerHTML;
          return;
        }

        let amount = minorAmount / 100;
        if (sourceCurrency !== displayCurrency) {
          amount = displayCurrency === 'DOP' ? amount * config.rate : amount / config.rate;
        }
        if (!Number.isFinite(amount)) {
          if (node.innerHTML !== original.nativeHTML) node.innerHTML = original.nativeHTML;
          original.renderedHTML = node.innerHTML;
          return;
        }
        const formatted = formatMoney(amount, displayCurrency, config.locale);
        if (node.textContent !== formatted) node.textContent = formatted;
        original.renderedHTML = node.innerHTML;
      });

      document.querySelectorAll(noticeSelector).forEach((notice) => {
        const checkoutCurrency = notice.dataset.checkoutCurrency;
        const show = canConvert && currencies.has(checkoutCurrency) && displayCurrency !== checkoutCurrency;
        notice.hidden = !show;
        if (show) {
          const message = checkoutCurrency === 'USD' ? notice.dataset.checkoutUsd : notice.dataset.checkoutDop;
          if (notice.textContent !== message) notice.textContent = message;
        }
      });

      const state = {
        source: config?.source || null,
        displayCurrency: displayCurrency || null,
        rate: config?.validRate ? config.rate : null,
        locale: config?.locale || 'es-DO',
        canConvert,
      };
      const signature = JSON.stringify(state);
      if (stateSignature !== signature) {
        stateSignature = signature;
        currentState = Object.freeze(state);
        document.dispatchEvent(new CustomEvent('sya:currency:change', { detail: currentState }));
      }
    };

    const scheduleRender = () => {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(render);
    };

    document.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.matches(selectSelector)) return;
      if (!currencies.has(event.target.value) || event.target.disabled) return;
      preference = event.target.value;
      try {
        window.localStorage.setItem(storageKey, preference);
      } catch {}
      render();
    });

    window.addEventListener('storage', (event) => {
      if (event.key !== storageKey && event.key !== null) return;
      const config = readConfig();
      if (!config) return;
      preference = currencies.has(event.newValue) ? event.newValue : config.defaultCurrency;
      render();
    });

    const relevantSelector = `${moneySelector},${configSelector},${noticeSelector}`;
    const isRelevant = (node) => node instanceof Element && (node.matches(relevantSelector) || node.querySelector(relevantSelector));
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => {
        if (mutation.type === 'attributes') return true;
        if (mutation.target instanceof Element && mutation.target.closest(relevantSelector)) return true;
        return [...mutation.addedNodes, ...mutation.removedNodes].some(isRelevant);
      })) scheduleRender();
    });
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-amount', 'data-currency', 'data-dop-per-usd', 'data-source-currency', 'data-default-currency', 'data-locale', 'data-checkout-currency'],
    });

    render();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sya-language-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sya-language-selector')) {
    class SyaLanguageSelector extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.onLanguageChange);
        this.addEventListener('submit', this.onLanguageSubmit);
        const form = this.querySelector('form');
        const submit = this.querySelector('button[type="submit"]');
        if (form && submit && typeof form.requestSubmit === 'function') submit.hidden = true;
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onLanguageChange);
        this.removeEventListener('submit', this.onLanguageSubmit);
      }

      onLanguageSubmit = (event) => {
        if (event.target !== this.querySelector('form')) return;
        document.dispatchEvent(new CustomEvent('sya:language-will-change'));
      };

      onLanguageChange = (event) => {
        const select = event.target;
        if (!(select instanceof HTMLSelectElement) || select.name !== 'language_code') return;
        if (select.value === this.dataset.currentLanguage) return;
        const form = select.form;
        if (form && typeof form.requestSubmit === 'function') form.requestSubmit();
      };
    }

    customElements.define('sya-language-selector', SyaLanguageSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
